export class AdapterString extends String {
  charAt(_: number): string {
    return this.valueOf();
  }
}
